import React, { Component, useState, useEffect } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  CardFooter,
  FormGroup,
  Label,
  Row,
  Col,
  Table,
  Input,
  CustomInput,
  InputGroup,
  InputGroupAddon,
  ButtonGroup,
  // Dropdown,
  // DropdownToggle,
  // DropdownMenu,
  Pagination,
  PaginationItem,
  PaginationLink,
  Badge,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
// import TableScrollbar from "react-table-scrollbar";
import { connect } from "react-redux";
import moment from "moment";
import FiltertRightbar from "../FiltersRightbar";

import "./NewPurchaseRequest.scss";
import swal from "sweetalert";
import Swal from "sweetalert2";

import {
  getUserLocations,
  getMiniDepartment,
  getUserDepartment,
  getSubOrderLocations,
} from "../../../store/Mini/actions";

import {
  MR_model_open,
  SetParams,
  InputChangeValue,
  SelecteChangeValue,
  getPIReqestRowDetails,
  SIInputChangeValue,
  SISelecteChangeValue,
  removeSelectProducts,
  addPurchaseIndent,
  getPIAllProducts,
  getProductStoreQty,
  SRDetailsModel_open,
  //--------------
  getSRList,
  MRItemsChecked,
  AllMRItemsChecked,
  PISelectedItems,
  FiltersShowRightSidebar,
} from "../../../store/SRPurchaseIndent/actions";

import {
  ChangeItemModelOpen,
  getAllProducts,
} from "../../../store/MaterialRequest/actions";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import GetMRDetails from "../../GetSRDetails";
import ItemDetails from "../../ItemDetails";
import ChangeItem from "../../Material/ChangeItem";
import CancleItemModel from "../../cancelItemModel";

function PdfViewer({ url }) {
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        let finalUrl = url;

        if (
          window.location.hostname === "localhost" &&
          url.startsWith("http://vendpin.dev.absol.in")
        ) {
          finalUrl = url.replace("http://vendpin.dev.absol.in", "");
        }

        const response = await fetch(finalUrl);
        if (!response.ok) throw new Error("Network response was not ok");

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        setPdfBlobUrl(blobUrl);
      } catch (err) {
        console.error("Failed to load PDF", err);
      }
    };
    fetchPdf();
  }, [url]);

  if (!pdfBlobUrl)
    return <p style={{ padding: "10px" }}>Loading PDF preview...</p>;

  return (
    <iframe
      src={pdfBlobUrl}
      width="100%"
      height="600px"
      style={{ border: "none" }}
      title="PDF Document"
    />
  );
}
class PurchaseRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_Cancel: false,
      item_details: [],
      selectedOrderLocation: null,
      showImageModal: false,
      //--------
    };
    this.ChangeHandeler = this.ChangeHandeler.bind(this);
    this.SItemChangeHandeler = this.SItemChangeHandeler.bind(this);
    this.removeCartItem = this.removeCartItem.bind(this);
    this.handleValidPISubmit = this.handleValidPISubmit.bind(this);
    this.tog_static = this.tog_static.bind(this);
    this.itemCancle_static = this.itemCancle_static.bind(this);
    this.getNewItem = this.getNewItem.bind(this);
    //---------
  }

  //---------------------------------------

  tog_static(item) {
    this.setState((prevState) => ({
      modal_static: !prevState.modal_static,
      item_details: item,
    }));

    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  itemCancle_static(Item) {
    this.setState((prevState) => ({
      modal_Cancel: !prevState.modal_Cancel,
      item_details: Item,
    }));
  }
  componentDidMount() {
    this.props.getUserLocations();
    this.props.getUserDepartment();
    this.props.getMiniDepartment();
    this.props.getSubOrderLocations();
    this.props.getSRList({
      ...this.props.params,
      // MrId: this.props.openMRid,
      // Index: this.props.openMRindex,
      // search: e.target.value,
      page: 1,
    });

    if (this.props.match.params.id !== "0") {
      this.props.getPIReqestRowDetails(
        this.props.match.params.id,
        this.props.history
      );
    }
  }
  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  SItemChangeHandeler(e, item) {
    // var itemqty = item.piimris.map((i) => {
    //   return i.qty + i.mritem.availableqty;
    // });
    // var totalitemqty = itemqty.reduce((total, itemqty) => total + itemqty);

    // if (e.target.value >= totalitemqty) {
    //   this.props.SIInputChangeValue({
    //     key: e.target.name,
    //     value: parseFloat(e.target.value),
    //     item,
    //   });
    // } else {
    //   swal("Minimum Quantity is " + totalitemqty, {
    //     icon: "error",
    //   });
    this.props.SIInputChangeValue({
      key: e.target.name,
      value: e.target.value,
      item,
    });
    // }
  }

  handleValidPISubmit() {
    if (this.props.PISelectItem.length !== 0) {
      this.setState({ loading: true });
      var piitems = this.props.PISelectItem.map((p) => {
        var siisris = p.piimris.map((i) => {
          i.unit_id = i.unit.id;
          i.sritem_id = i.mritem.id;
          return i;
        });
        p.qty = p.t_qty == null ? p.qty : p.t_qty;
        p.product_id = p.product.id;
        p.unit_id = p.t_unit == null ? p.unit.id : p.t_unit.id;
        p.siisris = siisris;
        return p;
      });
      var data = {
        location_id:
          this.props.PIRowData?.location_id == null
            ? this.props.userLocation[0].id
            : this.props.PIRowData.location_id,
        orderlocation_id:
          this.props.PIRowData?.orderlocation_id == null
            ? this.props.minisublocationslist[0].id
            : this.props.PIRowData.orderlocation_id,
        department_id:
          this.props.PIRowData?.userdepartment_id == null
            ? this.props.userDeparment[0].id
            : this.props.PIRowData.userdepartment_id,
        userdepartment_id:
          this.props.PIRowData?.userdepartment_id == null
            ? this.props.userDeparment[0].id
            : this.props.PIRowData.userdepartment_id,
        description: this.props.PIRowData?.description,
        siitems: piitems,
      };

      this.props.addPurchaseIndent(
        data,
        this.props.match.params.id,
        this.props.history
      );
    } else {
      // swal("Select Items", {
      //   icon: "error",
      // });
      this.setState({ loading: false });
      Swal.fire({
        icon: "error",
        text: "Select Items",
      });
    }
  }
  // getMRdata() {
  //   var data = {
  //     start_date: this.props.PIRowData?.Fdate,
  //     end_date: this.props.PIRowData?.Tdate,
  //     // location: this.props.PIRowData?.location_id,
  //     department: this.props.PIRowData?.department_id,
  //     // userdepartment: this.props.PIRowData?.userdepartment_id,
  //   };
  //   this.props.getSRList(data);

  //   // if (data.department == null) {
  //   //   swal("Select Material  Department", {
  //   //     icon: "error",
  //   //   });
  //   // } else {
  //   // }
  // }
  getNewItem() {
    this.props.getPIAllProducts(
      { ...this.props.params, page: 1, search: "", type: 2 },
      true
    );
  }
  //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  onSortChange = () => {
    var sort = ["materialrequest__id", "date"];
    var mrcurrentSort = this.props.params.MRcurrentSort;
    var i = sort.indexOf(mrcurrentSort);
    if (i !== -1 && i + 1 < sort.length) {
      mrcurrentSort = sort[i + 1];
    } else {
      mrcurrentSort = sort[0];
    }
    this.props.SetParams({
      ...this.props.params,
      MRcurrentSort: mrcurrentSort,
    });
    this.props.getSRList({
      ...this.props.params,
      MRcurrentSort: mrcurrentSort,
      id: this.props.PISelectItemIDS,
    });
  };
  onSortOrderChange = () => {
    var sortOrder = this.props.params.sortOrder;
    if (sortOrder === "") {
      sortOrder = "-";
    } else {
      sortOrder = "";
    }

    this.props.SetParams({ ...this.props.params, sortOrder: sortOrder });
    this.props.getSRList({
      ...this.props.params,
      sortOrder: sortOrder,
      id: this.props.PISelectItemIDS,
    });
  };
  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.getSRList({
        ...this.props.params,
        page: 1,
        search: e.target.value,
        id: this.props.PISelectItemIDS,
      });
    }
  };
  SearchHandle = (e) => {
    this.props.SetParams({
      ...this.props.params,
      search: e.target.value,
      page: 1,
    });
    if (e.target.value === "") {
      this.props.getSRList({
        ...this.props.params,
        page: 1,
        search: "",
        id: this.props.PISelectItemIDS,
      });
    }
  };
  getCheckedSubItem(e, item, index) {
    this.props.MRItemsChecked(e.target.checked, item, index);
    // this.props.PISelectedItems(e.target.checked, item, index);
  }
  getAllCheckedSubItem(e) {
    this.props.AllMRItemsChecked(e.target.checked);
    // this.props.MRlist.forEach((item, key) => {
    //   this.props.PISelectedItems(
    //     e.target.checked,
    //     item,
    //     key
    //   );
    // });
  }
  requestingItems() {
    var selected_ids = [];
    if (this.props.MRlistChecked.length === 0) {
      swal({ title: "Select Items", icon: "error" });
    } else {
      this.props.MRlist.forEach((item, i) => {
        if (item.itemcheck === true) {
          this.props.PISelectedItems(true, item);

          selected_ids.push(item.id);
        }
        if (i === this.props.MRlist.length - 1) {
          this.props.SetParams({
            ...this.props.params,
            page: 1,
          });
          this.props.getSRList({
            ...this.props.params,
            page: 1,

            id: [...this.props.PISelectItemIDS, ...selected_ids],
          });
        }
      });
    }
  }
  removeCartItem = (item) => {
    this.props.removeSelectProducts(item);
    var ids = this.props.PISelectItemIDS.filter((id) => id !== item.MR_Item_id);
    this.props.SetParams({
      ...this.props.params,
      page: 1,
      search: "",
    });
    this.props.getSRList({
      ...this.props.params,
      page: 1,
      search: "",
      id: ids,
    });
  };
  openPage(pageNo) {
    this.props.SetParams({ ...this.props.params, page: pageNo });
    this.props.getSRList({
      ...this.props.params,
      page: pageNo,
      id: this.props.PISelectItemIDS,
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col xl={5} className="p-1 W-100">
                <Card className="p-0">
                  <CardHeader className="bg-transparent border-bottom ">
                    <Link
                      to="/srpidashboard"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <h5 className="card-title-18 pt-2 d-inline-block">
                      New SR Purchase Indent Request
                    </h5>
                  </CardHeader>
                  <CardBody className="pt-0 ">
                    <div style={{ height: "750px" }}>
                      <Row>
                        <Col lg={12} className="m-2">
                          <div className="float-left">
                            <FormGroup className="m-0 pb-0">
                              <InputGroup>
                                <Input
                                  type="text"
                                  name="search"
                                  className="form-control d-inline-block"
                                  placeholder="Search"
                                  value={
                                    this.props.params.search === ""
                                      ? ""
                                      : this.props.params.search
                                  }
                                  validate={{
                                    required: true,
                                  }}
                                  onChange={(e) => this.SearchHandle(e)}
                                  onKeyDown={(e) => this.handleSearch(e)}
                                />
                                <InputGroupAddon addonType="append">
                                  <Button
                                    color="light"
                                    type="submit"
                                    onClick={() =>
                                      this.props.getSRList({
                                        ...this.props.params,
                                        page: 1,
                                        id: this.props.PISelectItemIDS,
                                      })
                                    }
                                  >
                                    <i className="ri-search-line"></i>
                                  </Button>
                                </InputGroupAddon>
                              </InputGroup>
                            </FormGroup>
                          </div>

                          <div className="float-right">
                            <div className="d-inline-block">
                              <Button
                                type="button"
                                color="light"
                                className="waves-effect waves-light d-flex"
                                onClick={() =>
                                  this.props.FiltersShowRightSidebar(3)
                                }
                              >
                                <i className="mdi mdi-filter"></i>
                              </Button>
                            </div>

                            <ButtonGroup className="waves-effect waves-light d-inline-block ml-2 mr-2">
                              <Button
                                color="light"
                                onClick={this.onSortOrderChange}
                              >
                                {this.props.params.sortOrder === "" && (
                                  <i className="mdi mdi-sort-ascending mr-1"></i>
                                )}
                                {this.props.params.sortOrder === "-" && (
                                  <i className="mdi mdi-sort-descending mr-1"></i>
                                )}
                              </Button>
                              <Button color="light" onClick={this.onSortChange}>
                                {
                                  this.props.SortMRVar[
                                    this.props.params.MRcurrentSort
                                  ]
                                }
                              </Button>
                            </ButtonGroup>

                            <Button
                              type="button"
                              color="success"
                              className="waves-effect waves-light mr-2"
                              onClick={() => this.requestingItems()}
                            >
                              <i className="mdi mdi-cart-outline mr-2"></i>
                              Add to List
                            </Button>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12} className="m-2">
                          <div
                            className="table-responsive  table-bordered mt-2"
                            style={{
                              maxHeight: "550px",
                              overflowY: "auto",
                            }}
                          >
                            <Table className="table-centered mb-0 table-nowrap">
                              <thead className="bg-light text-center">
                                <tr>
                                  <th
                                    style={{
                                      width: "20px",
                                    }}
                                  >
                                    <div>
                                      <CustomInput
                                        type="checkbox"
                                        name="itemCheckbox"
                                        id="iCheckbox"
                                        checked={this.props.allItemsCheked}
                                        onChange={(e) => {
                                          this.getAllCheckedSubItem(e);
                                        }}
                                      />
                                    </div>
                                  </th>
                                  <th
                                    style={{
                                      width: "120px",
                                    }}
                                  >
                                    SR No
                                  </th>
                                  <th
                                    style={{
                                      width: "220px",
                                    }}
                                  >
                                    Item Name
                                  </th>
                                  <th
                                    style={{
                                      width: "220px",
                                    }}
                                  >
                                    Quantity
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.props.MRlist.length !== 0 ? (
                                  <>
                                    {this.props.MRlist.map((item, key) => (
                                      <tr key={key}>
                                        <td className="text-center">
                                          <div>
                                            <CustomInput
                                              type="checkbox"
                                              name="itemCheckbox"
                                              id={"icheckbox" + item.id}
                                              checked={item.itemcheck}
                                              onChange={(e) => {
                                                this.getCheckedSubItem(
                                                  e,
                                                  item,
                                                  key
                                                );
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <td className="text-center">
                                          <Link
                                            to="#"
                                            onClick={() => {
                                              this.props.SRDetailsModel_open(
                                                item.servicerequest_id
                                              );
                                            }}
                                            className="text-primary mr-1"
                                          >
                                            {item.code}-{item.servicerequest_code}
                                          </Link>
                                          <br />
                                          {item.createdby}
                                        </td>
                                        <td>
                                          <h5 className="font-size-14 text-truncate">
                                            <Link
                                              to="#"
                                              onClick={() => {
                                                this.tog_static(item);
                                              }}
                                              className="text-dark"
                                            >
                                              {item.product.name}
                                            </Link>
                                            {item.mistatus === 1 &&
                                              item.sistatus === 1 && (
                                                <>
                                                  <Link
                                                    to="#"
                                                    onClick={() => {
                                                      this.itemCancle_static(
                                                        item
                                                      );
                                                    }}
                                                    className="ml-2 text-danger"
                                                  >
                                                    <i className="ri-delete-bin-2-line"></i>
                                                  </Link>
                                                </>
                                              )}
                                            {item.srstatus !== 11 && (
                                              <Link
                                                to="#"
                                                onClick={() => {
                                                  this.props.ChangeItemModelOpen(
                                                    item,
                                                    "MRISUser"
                                                  );
                                                  this.props.getAllProducts(
                                                    {
                                                      ...this.props.params,
                                                      search: "",
                                                      page: 1,
                                                    },
                                                    true
                                                  );
                                                }}
                                                className="ml-2 text-primary"
                                              >
                                                <i className="ri-pencil-line"></i>
                                              </Link>
                                            )}
                                          </h5>
                                          {item.srstatus === 11 && (
                                            <p className="mb-0">
                                              <span className="font-weight-medium">
                                                <span className="text-dark">
                                                  Status:
                                                </span>{" "}
                                                <span className="text-danger">
                                                  {item.mrstatus_name}
                                                </span>
                                              </span>
                                            </p>
                                          )}
                                          <p className="mb-0">
                                            <span className="font-weight-medium">
                                              <span className="text-dark">
                                                Make :
                                              </span>{" "}
                                              {item.make}
                                            </span>
                                          </p>
                                          <p className="mb-0">
                                            <span className="font-weight-medium">
                                              <span className="text-dark">
                                                Request Date :{" "}
                                              </span>
                                              {moment(item.date).format(
                                                "DD-MM-YYYY"
                                              )}
                                            </span>
                                          </p>
                                          <p className="mb-0">
                                            Available Qty:{" "}
                                            <>
                                              {item.StockQty !== null ? (
                                                <>
                                                  <span className="font-weight-medium text-success">
                                                    {item.StockQty}{" "}
                                                  </span>
                                                  {item.StockQty === 0 && (
                                                    <>
                                                      <Badge color={"danger"}>
                                                        No Stock
                                                      </Badge>
                                                    </>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {!item.StockQtyLoading ? (
                                                    <Link
                                                      to="#"
                                                      onClick={() => {
                                                        this.props.getProductStoreQty(
                                                          item.product.id
                                                        );
                                                      }}
                                                      className="text-primary"
                                                    >
                                                      <u> Check Stock </u>
                                                    </Link>
                                                  ) : (
                                                    <>
                                                      <span className="font-weight-medium text-primary">
                                                        Loading
                                                      </span>
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          </p>
                                        </td>

                                        <td className="text-center">
                                          {item?.availableqty /
                                            item?.unit?.units}{" "}
                                          {item?.unit?.name}
                                        </td>
                                      </tr>
                                    ))}
                                  </>
                                ) : (
                                  <tr>
                                    <td colSpan={6}>
                                      <div className="text-center">
                                        <span className="font-size-18 text-danger">
                                          Data not available{" "}
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <div className="float-right p-1">
                            <div className="d-inline-block">
                              <Pagination aria-label="Page navigation example">
                                <PaginationItem
                                  disabled={this.props.params.page <= 1}
                                >
                                  <PaginationLink
                                    onClick={(e) => this.openPage(1)}
                                    previous
                                  />
                                </PaginationItem>

                                {this.props.params.page > 2 && (
                                  <PaginationItem
                                    disabled={this.props.params.page <= 2}
                                  >
                                    <PaginationLink
                                      onClick={() =>
                                        this.openPage(
                                          this.props.params.page - 2
                                        )
                                      }
                                    >
                                      {this.props.params.page - 2}
                                    </PaginationLink>
                                  </PaginationItem>
                                )}
                                {this.props.params.page > 1 && (
                                  <PaginationItem
                                    disabled={this.props.params.page === 1}
                                  >
                                    <PaginationLink
                                      onClick={() =>
                                        this.openPage(
                                          this.props.params.page - 1
                                        )
                                      }
                                    >
                                      {this.props.params.page - 1}
                                    </PaginationLink>
                                  </PaginationItem>
                                )}

                                <PaginationItem active={true}>
                                  <PaginationLink
                                    onClick={() =>
                                      this.openPage(this.props.params.page)
                                    }
                                  >
                                    {this.props.params.page}
                                  </PaginationLink>
                                </PaginationItem>
                                {this.props.params.page + 1 <=
                                  this.props.params.no_of_pages && (
                                  <PaginationItem
                                    disabled={
                                      this.props.params.page + 1 >
                                      this.props.params.no_of_pages
                                    }
                                  >
                                    <PaginationLink
                                      onClick={() =>
                                        this.openPage(
                                          this.props.params.page + 1
                                        )
                                      }
                                    >
                                      {this.props.params.page + 1}
                                    </PaginationLink>
                                  </PaginationItem>
                                )}
                                {this.props.params.page + 2 <=
                                  this.props.params.no_of_pages && (
                                  <PaginationItem
                                    disabled={
                                      this.props.params.page + 2 >
                                      this.props.params.no_of_pages
                                    }
                                  >
                                    <PaginationLink
                                      onClick={() =>
                                        this.openPage(
                                          this.props.params.page + 2
                                        )
                                      }
                                    >
                                      {this.props.params.page + 2}
                                    </PaginationLink>
                                  </PaginationItem>
                                )}
                                {this.props.params.page + 3 <=
                                  this.props.params.no_of_pages &&
                                  this.props.params.page < 3 && (
                                    <PaginationItem
                                      disabled={
                                        this.props.params.page + 3 >
                                        this.props.params.no_of_pages
                                      }
                                    >
                                      <PaginationLink
                                        onClick={() =>
                                          this.openPage(
                                            this.props.params.page + 3
                                          )
                                        }
                                      >
                                        {this.props.params.page + 3}
                                      </PaginationLink>
                                    </PaginationItem>
                                  )}
                                {this.props.params.page + 4 <=
                                  this.props.params.no_of_pages &&
                                  this.props.params.page < 2 && (
                                    <PaginationItem
                                      disabled={
                                        this.props.params.page + 4 >
                                        this.props.params.no_of_pages
                                      }
                                    >
                                      <PaginationLink
                                        onClick={() =>
                                          this.openPage(
                                            this.props.params.page + 4
                                          )
                                        }
                                      >
                                        {this.props.params.page + 4}
                                      </PaginationLink>
                                    </PaginationItem>
                                  )}

                                <PaginationItem
                                  disabled={
                                    this.props.params.no_of_pages ===
                                    this.props.params.page
                                  }
                                >
                                  <PaginationLink
                                    onClick={(e) =>
                                      this.openPage(
                                        this.props.params.no_of_pages
                                      )
                                    }
                                    next
                                  />
                                </PaginationItem>
                              </Pagination>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col xl={this.state.showImageModal ? 4 : 7} className="p-1 W-100">
                <Card className="p-0">
                  <CardHeader className="bg-transparent border-bottom ">
                    <h3 className="card-title-15 pt-2">Purchase Items List</h3>
                  </CardHeader>
                  <AvForm onValidSubmit={this.handleValidPISubmit}>
                    <CardBody>
                      <div style={{ height: "550px" }}>
                        <Row>
                          <Col md={4}>
                            <FormGroup className="mb-0">
                              <Label className="col-form-label">
                                Locations:
                              </Label>
                              <Select
                                id="location_id_select"
                                name="location_id_select"
                                classNamePrefix="select2-selection"
                                options={this.props.userLocation.map(
                                  (item) => ({
                                    label: item.name,
                                    value: item.id,
                                  })
                                )}
                                value={{
                                  label:
                                    this.props.PIRowData?.locationLabel ||
                                    this.props.userLocation[0]?.name,
                                  value:
                                    this.props.PIRowData?.location_id ||
                                    this.props.userLocation[0]?.id,
                                }}
                                onChange={(e) => {
                                  this.props.SelecteChangeValue({
                                    key: "locationLabel",
                                    label: e.label,
                                    key2: "location_id",
                                    value: e.value,
                                  });
                                }}
                              />
                            </FormGroup>
                          </Col>

                          <Col md={4}>
                            <FormGroup className="mb-0">
                              <Label className="col-form-label">
                                Order Locations:
                              </Label>
                              <div className="d-flex align-items-end">
                                <div className="flex-grow-1 mr-2">
                                  <Select
                                    id="orderlocation_id_select"
                                    name="orderlocation_id_select"
                                    classNamePrefix="select2-selection"
                                    options={this.props.minisublocationslist.map(
                                      (item) => ({
                                        label: item.name,
                                        value: item.id,
                                      })
                                    )}
                                    value={{
                                      label:
                                        this.props.PIRowData
                                          ?.orderlocationLabel ||
                                        this.props.minisublocationslist[0]
                                          ?.name,
                                      value: this.props.PIRowData
                                        ?.orderlocation_id
                                        ? {
                                            label:
                                              this.props.PIRowData
                                                .orderlocationLabel,
                                            value:
                                              this.props.PIRowData
                                                .orderlocation_id,
                                          }
                                        : null,
                                    }}
                                    onChange={(e) => {
                                      this.props.SelecteChangeValue({
                                        key: "orderlocationLabel",
                                        label: e.label,
                                        key2: "orderlocation_id",
                                        value: e.value,
                                      });

                                      const selected =
                                        this.props.minisublocationslist.find(
                                          (item) => item.id === e.value
                                        );
                                      this.setState({
                                        selectedOrderLocation: selected,
                                      });
                                    }}
                                  />
                                </div>
                                <Button
                                  color="info"
                                  size="sm"
                                  style={{
                                    whiteSpace: "nowrap",
                                  }}
                                  disabled={
                                    !this.state.selectedOrderLocation?.image
                                  }
                                  onClick={() =>
                                    this.setState({
                                      showImageModal: true,
                                    })
                                  }
                                >
                                  View
                                </Button>
                              </div>
                            </FormGroup>
                          </Col>

                          <Col md={4}>
                            <FormGroup className="mb-0">
                              <Label className="col-form-label">
                                User Dept :
                              </Label>
                              <Select
                                id="User_department_select"
                                name="User_department_select"
                                classNamePrefix="select2-selection"
                                options={this.props.userDeparment.map(
                                  (item) => ({
                                    label: item.name,
                                    value: item.id,
                                  })
                                )}
                                value={{
                                  label:
                                    this.props.PIRowData?.userdepartmentLabel ||
                                    this.props.userDeparment[0]?.name,
                                  value:
                                    this.props.PIRowData?.userdepartment_id ||
                                    this.props.userDeparment[0]?.id,
                                }}
                                onChange={(e) => {
                                  this.props.SelecteChangeValue({
                                    key: "userdepartmentLabel",
                                    label: e.label,
                                    key2: "userdepartment_id",
                                    value: e.value,
                                  });
                                }}
                              />
                            </FormGroup>
                          </Col>

                          <Col
                            md={{
                              size: 4,
                              offset: 8,
                            }}
                            className="mt-2"
                          >
                            <Button
                              type="button"
                              color="light"
                              className="waves-effect waves-light"
                              onClick={() => this.getNewItem()}
                            >
                              <i className="mdi mdi-plus-circle-outline mr-2"></i>
                              Add Item
                            </Button>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12} className="m-2">
                            <div
                              className="table-responsive  table-bordered m-0"
                              style={{
                                maxHeight: "480px",
                                overflowY: "auto",
                              }}
                            >
                              <Table className="mb-0 p-0 table-centered">
                                <thead className="bg-light text-center">
                                  <tr>
                                    <th className="nowrap">SR No</th>
                                    <th className="nowrap">Item Images</th>
                                    <th
                                      style={{
                                        minWidth: "140px",
                                      }}
                                    >
                                      Item Name
                                    </th>
                                    <th className="nowrap">Required Qty</th>
                                    <th
                                      style={{
                                        minWidth: "140px",
                                      }}
                                    >
                                      Indent Quantity
                                    </th>

                                    <th className="nowrap">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.props.PISelectItem.length !== 0 ? (
                                    <>
                                      {this.props.PISelectItem.map(
                                        (item, key) => (
                                          <>
                                            {!item.dodelete && (
                                              <tr key={item.id}>
                                                <td className="nowrap text-center">
                                                  <Link
                                                    to="#"
                                                    onClick={() => {
                                                      this.props.SRDetailsModel_open(
                                                        item.MR_id
                                                      );
                                                    }}
                                                    className="text-primary mr-1"
                                                  >
                                                    {item.MRCode}
                                                  </Link>
                                                </td>
                                                <td className="nowrap text-center">
                                                  <div className="product-detail text-center">
                                                    <img
                                                      src={
                                                        item?.product?.image ==
                                                        null
                                                          ? DefaultImg
                                                          : item?.product?.image
                                                      }
                                                      alt="product-img"
                                                      title="product-img"
                                                      className="product-img  img-fluid mx-auto tab-img rounded"
                                                      style={{
                                                        height: "100px",
                                                        width: "150px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                                <td
                                                  style={{
                                                    minWidth: "140px",
                                                  }}
                                                >
                                                  <h5 className="font-size-14">
                                                    <Link
                                                      to="#"
                                                      onClick={() => {
                                                        this.tog_static(item);
                                                      }}
                                                      className="text-dark"
                                                    >
                                                      {item.product.name}
                                                    </Link>
                                                  </h5>
                                                  <p className="mb-0">
                                                    Make :{" "}
                                                    <span className="font-weight-medium">
                                                      {item.make}
                                                    </span>
                                                  </p>
                                                  <p className="mb-0">
                                                    Description :{" "}
                                                    <span className="font-weight-medium">
                                                      {item.description}
                                                    </span>
                                                  </p>
                                                </td>
                                                <td className="nowrap text-center">
                                                  {item.qty} {item.unit.name}
                                                </td>
                                                <td
                                                  className="text-center"
                                                  style={{
                                                    minWidth: "140px",
                                                  }}
                                                >
                                                  <FormGroup
                                                    row
                                                    className="mb-0"
                                                  >
                                                    <Col md={4}>
                                                      <Label
                                                        htmlFor="Qty"
                                                        className="col-form-label float-left"
                                                      >
                                                        Qty :
                                                      </Label>
                                                    </Col>
                                                    <Col md={8}>
                                                      <AvField
                                                        placeholder="Quantity"
                                                        className=" pr-0form-control"
                                                        min={0}
                                                        // max={100}
                                                        type="number"
                                                        // step="1"
                                                        name={key + "qty"}
                                                        id="qty"
                                                        value={item.qty}
                                                        validate={{
                                                          required: {
                                                            value: true,
                                                            errorMessage:
                                                              "Please enter Qty",
                                                          },
                                                          pattern: {
                                                            value:
                                                              "^[0-9]{1,18}([.-]?)[0-9]{0,3}$",
                                                            errorMessage:
                                                              "Qty can compose numbers and 3 decimals ",
                                                          },
                                                        }}
                                                        onChange={(e) =>
                                                          this.SItemChangeHandeler(
                                                            e,
                                                            item
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                  </FormGroup>
                                                  <FormGroup
                                                    row
                                                    className="mb-0"
                                                  >
                                                    <Col md={4}>
                                                      <Label
                                                        htmlFor="Units"
                                                        className="col-form-label float-left"
                                                      >
                                                        Units :
                                                      </Label>
                                                    </Col>
                                                    <Col md={8}>
                                                      <Select
                                                        id="units_select"
                                                        name="units_select"
                                                        required="required"
                                                        options={item?.product?.units?.map(
                                                          (i) => ({
                                                            label: i.name,
                                                            value: i.id,
                                                          })
                                                        )}
                                                        value={{
                                                          label: item.unit.name,
                                                          value: item.unit.id,
                                                        }}
                                                        onChange={(e) => {
                                                          this.props.SISelecteChangeValue(
                                                            {
                                                              key: "unit_name",
                                                              label: e.label,
                                                              key2: "unit_id",
                                                              value: e.value,
                                                              item,
                                                            }
                                                          );
                                                        }}
                                                      />
                                                    </Col>
                                                  </FormGroup>
                                                </td>

                                                <td className="nowrap text-center">
                                                  <Button
                                                    type="reset"
                                                    color="danger"
                                                    className="waves-effect waves-light"
                                                    onClick={() =>
                                                      this.removeCartItem(item)
                                                    }
                                                  >
                                                    <i className="mdi mdi-close"></i>
                                                    {/* Remove */}
                                                  </Button>
                                                </td>
                                              </tr>
                                            )}
                                          </>
                                        )
                                      )}
                                    </>
                                  ) : (
                                    <tr>
                                      <td colSpan={6}>
                                        <div className="text-center">
                                          <span className="font-size-18 text-danger">
                                            Data not available{" "}
                                          </span>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <CardFooter className="bg-transparent pt-0">
                        <Card className="p-0 m-0">
                          <CardHeader className="bg-transparent border-bottom p-1">
                            <i className="mdi mdi-alert-circle-outline ml-2 mr-2 font-size-20"></i>

                            <h5 className="card-title-15 d-inline-block">
                              Description
                            </h5>
                          </CardHeader>
                          <CardBody className="p-2 ">
                            <div>
                              <FormGroup className="mb-0">
                                <AvField
                                  name="description"
                                  id="description"
                                  type="textarea"
                                  className="form-control"
                                  placeholder="Enter Details"
                                  value={this.props.PIRowData?.description}
                                  rows="2"
                                  onChange={this.ChangeHandeler}
                                />
                              </FormGroup>{" "}
                            </div>
                          </CardBody>
                        </Card>
                        <div className="float-right m-3">
                          <Button
                            type="button"
                            color="light"
                            className="waves-effect waves-light mr-2"
                            href="/PurchaseIndentDashboard"
                          >
                            {/* <i className="mdi mdi-filter mr-1"></i> */}
                            Cancel
                          </Button>
                          <Button
                            // type="button"
                            type="submit"
                            color="primary"
                            className="waves-effect waves-light"
                            disabled={
                              this.props.PISelectItem.length !== 0
                                ? false
                                : true
                            }
                            // onClick={this.handleValidPISubmit}
                            loading={this.props.loading}
                          >
                            Submit
                          </Button>
                        </div>
                      </CardFooter>
                    </CardBody>
                  </AvForm>
                </Card>
              </Col>

              {this.state.showImageModal &&
                this.state.selectedOrderLocation?.image && (
                  <Col md={12} xl={3}>
                    <Card className="p-1">
                      <CardHeader>
                        <h5>
                          Order Location Document:{" "}
                          {this.state.selectedOrderLocation.name}
                        </h5>
                        <Button
                          color="secondary"
                          size="sm"
                          className="float-right"
                          onClick={() =>
                            this.setState({
                              showImageModal: false,
                            })
                          }
                        >
                          Close
                        </Button>
                      </CardHeader>
                      <CardBody className="p-0">
                        {this.state.selectedOrderLocation?.image ? (
                          (() => {
                            const rawUrl =
                              this.state.selectedOrderLocation.image;
                            const cleanUrl = rawUrl.trim();
                            const isPdf = /\.pdf(\?.*)?$/i.test(cleanUrl);

                            return isPdf ? (
                              <PdfViewer url={cleanUrl} />
                            ) : (
                              <img
                                src={cleanUrl}
                                alt="Order Location"
                                style={{
                                  maxWidth: "100%",
                                  height: "auto",
                                }}
                              />
                            );
                          })()
                        ) : (
                          <p style={{ padding: 10 }}>No document available</p>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                )}
            </Row>
            <ItemDetails
              modelOpen={this.state.modal_static}
              item={this.state.item_details}
              ItemLevel="PILevel"
              modelClose={() => {
                this.setState({ modal_static: false });
              }}
            />
            <ChangeItem />

            <GetMRDetails />
            <FiltertRightbar />
            <CancleItemModel
              modelOpen={this.state.modal_Cancel}
              item={this.state.item_details}
              ItemCancelLevel="MRItemCancle"
              modelClose={() => {
                this.setState({ modal_Cancel: false });
              }}
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { deparmentslist, userLocation, userDeparment, minisublocationslist } =
    state.Mini;

  const {
    MRlistModel,
    model,
    PIRowData,
    PISelectItem,
    params,
    MRlist,
    MRlistChecked,
    allItemsCheked,
    SortMRVar,
    loading,
    PISelectItemIDS,
  } = state.SRpurchaseIndent;

  return {
    MRlistModel,
    userLocation,
    deparmentslist,
    userDeparment,
    PIRowData,
    PISelectItem,
    params,
    loading,
    PISelectItemIDS,

    //-----------
    MRlist,
    MRlistChecked,
    allItemsCheked,
    SortMRVar,
    //-------------
    model,
    minisublocationslist,
  };
};

export default connect(mapStatetoProps, {
  MR_model_open,
  SetParams,
  getUserLocations,
  getMiniDepartment,
  getUserDepartment,
  InputChangeValue,
  SelecteChangeValue,
  getPIReqestRowDetails,
  SIInputChangeValue,
  SISelecteChangeValue,
  removeSelectProducts,
  addPurchaseIndent,
  getPIAllProducts,
  getProductStoreQty,
  SRDetailsModel_open,
  //------------
  getSRList,
  AllMRItemsChecked,
  MRItemsChecked,
  PISelectedItems,
  FiltersShowRightSidebar,
  // getMRRowList,
  //-----------

  ChangeItemModelOpen,
  getAllProducts,
  getSubOrderLocations,
})(PurchaseRequest);
